import PricingSection from "./components/PricingSection";

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200">
      <main>
        <PricingSection />
      </main>
    </div>
  );
}
